var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStrawberry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_349)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_349",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.500004H60.5V60.5H0.5V0.500004Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7107 4.83231C19.5731 4.73024 19.3864 4.73024 19.2489 4.83231C16.7087 6.7168 14.9742 10.4993 14.9742 14.8588C14.9742 19.2181 16.7087 23.0007 19.2489 24.8851C19.3864 24.987 19.5731 24.987 19.7107 24.8851C22.2509 23.0007 23.9854 19.2181 23.9854 14.8588C23.9854 10.4993 22.2509 6.7168 19.7107 4.83231Z",
    fill: "#09A76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7107 4.83231C19.5731 4.73024 19.3864 4.73024 19.2489 4.83231C16.7087 6.7168 14.9742 10.4993 14.9742 14.8588C14.9742 19.2181 16.7087 23.0007 19.2489 24.8851C19.3864 24.987 19.5731 24.987 19.7107 24.8851C22.2509 23.0007 23.9854 19.2181 23.9854 14.8588C23.9854 10.4993 22.2509 6.7168 19.7107 4.83231Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18839 7.60567C6.01905 7.63074 5.88698 7.76293 5.86191 7.93227C5.39819 11.0608 6.8464 14.962 9.92902 18.0446C13.0116 21.1271 16.9127 22.5753 20.0414 22.1117C20.2107 22.0866 20.3428 21.9545 20.3678 21.7851C20.8316 18.6564 19.3834 14.7554 16.3007 11.6729C13.2181 8.59027 9.31706 7.14195 6.18839 7.60567Z",
    fill: "#02905D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18839 7.60566C6.01905 7.63074 5.88698 7.76293 5.86191 7.93227C5.39819 11.0608 6.8464 14.962 9.92902 18.0446C13.0116 21.1271 16.9127 22.5753 20.0414 22.1117C20.2107 22.0866 20.3428 21.9545 20.3678 21.7851C20.8316 18.6564 19.3834 14.7554 16.3007 11.6729C13.2181 8.59027 9.31706 7.14195 6.18839 7.60566Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0977 7.93223C33.0726 7.76289 32.9405 7.63082 32.7712 7.60563C29.6425 7.14203 25.7415 8.59024 22.6589 11.6729C19.5762 14.7554 18.128 18.6565 18.5917 21.7851C18.6168 21.9545 18.7489 22.0866 18.9182 22.1117C22.0469 22.5754 25.948 21.1272 29.0306 18.0446C32.1132 14.962 33.5614 11.0609 33.0977 7.93223Z",
    fill: "#02905D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5273 8.83856C25.1766 9.52645 23.8559 10.4758 22.6588 11.6729C19.5763 14.7555 18.128 18.6565 18.5917 21.7852C18.6168 21.9545 18.749 22.0866 18.9182 22.1117C22.047 22.5754 25.948 21.1272 29.0305 18.0446C32.1132 14.962 33.5614 11.0609 33.0977 7.93223C33.0727 7.76289 32.9406 7.63082 32.7712 7.60563C32.0296 7.49582 31.2443 7.49465 30.437 7.5959",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0796 18.2807C22.9395 18.1766 22.8866 17.9919 22.9505 17.8293C23.7869 15.7031 26.0698 13.7671 29.0863 12.9041C32.1028 12.041 35.0643 12.4766 36.8986 13.8385C37.0388 13.9427 37.0916 14.1274 37.0278 14.2899C36.1914 16.4162 33.9085 18.3521 30.8921 19.2152C27.8755 20.0783 24.9141 19.6428 23.0796 18.2807Z",
    fill: "#09A76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 18.2807C16.0201 18.1766 16.0729 17.9919 16.0091 17.8293C15.1727 15.7031 12.8898 13.7671 9.87326 12.9041C6.85674 12.041 3.89529 12.4766 2.06096 13.8385C1.9208 13.9427 1.86795 14.1274 1.93181 14.2899C2.76818 16.4162 5.05111 18.3521 8.06752 19.2152C11.084 20.0783 14.0455 19.6428 15.8799 18.2807Z",
    fill: "#09A76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0796 18.2807C22.9395 18.1766 22.8866 17.9919 22.9505 17.8293C23.7869 15.7031 26.0698 13.7671 29.0863 12.9041C32.1029 12.041 35.0643 12.4766 36.8986 13.8385C37.0388 13.9427 37.0916 14.1274 37.0278 14.2899C36.1914 16.4162 33.9085 18.3521 30.8921 19.2152C27.8755 20.0783 24.9141 19.6428 23.0796 18.2807Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 18.2807C16.0201 18.1766 16.0729 17.9919 16.0091 17.8293C15.1727 15.7031 12.8898 13.7671 9.87326 12.9041C6.85674 12.041 3.89529 12.4766 2.06096 13.8385C1.9208 13.9427 1.86795 14.1274 1.93181 14.2899C2.76818 16.4162 5.05111 18.3521 8.06752 19.2152C11.084 20.0783 14.0455 19.6428 15.8799 18.2807Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4314 51.9893L36.3629 30.5811C39.8988 24.2369 35.312 16.4295 28.0489 16.4295H10.9107C3.64763 16.4295 -0.939209 24.2369 2.59669 30.5811L14.5281 51.9893C16.6899 55.868 22.2697 55.868 24.4314 51.9893Z",
    fill: "#FB2B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6805 51.9893L8.74906 30.5811C5.21316 24.2368 9.79988 16.4294 17.063 16.4294H10.9107C3.64754 16.4294 -0.939179 24.2368 2.59672 30.5811L14.5282 51.9893C16.2091 55.0051 19.9557 55.6748 22.556 54.0008C21.812 53.5219 21.1614 52.8521 20.6805 51.9893Z",
    fill: "#E41F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4314 51.9893L36.3629 30.5811C39.8988 24.2369 35.312 16.4295 28.0489 16.4295H10.9107C3.64763 16.4295 -0.939209 24.2369 2.59669 30.5811L14.5281 51.9893C16.6899 55.868 22.2697 55.868 24.4314 51.9893Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32329 27.4812V29.0216",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7609 27.4812V29.0216",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1987 27.4812V29.0216",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6363 27.4812V29.0216",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0422 21.7599V23.3002",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4798 21.7599V23.3002",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9174 21.7599V23.3002",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0422 33.9176V35.4579",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4798 33.9176V35.4579",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9174 33.9176V35.4579",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6179 39.958V41.4983",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0556 39.958V41.4983",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3367 46.5044V48.0448",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5269 25.6458C53.506 25.5054 53.3966 25.3958 53.2561 25.375C50.6622 24.9906 47.4279 26.1913 44.8721 28.747C42.3165 31.3028 41.1158 34.5372 41.5002 37.131C41.521 37.2715 41.6305 37.3809 41.771 37.4017C44.3647 37.7862 47.5992 36.5855 50.1549 34.0297C52.7106 31.474 53.9113 28.2397 53.5269 25.6458Z",
    fill: "#09A76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5269 25.6458C53.506 25.5054 53.3966 25.3958 53.2561 25.375C50.6622 24.9906 47.4279 26.1913 44.8721 28.747C42.3165 31.3028 41.1158 34.5372 41.5002 37.131C41.521 37.2715 41.6305 37.3809 41.771 37.4017C44.3647 37.7862 47.5992 36.5855 50.1549 34.0297C52.7106 31.474 53.9113 28.2397 53.5269 25.6458Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9735 19.3442C43.8594 19.2596 43.7046 19.2596 43.5906 19.3442C41.4846 20.9065 40.0466 24.0426 40.0466 27.657C40.0466 31.2713 41.4846 34.4074 43.5906 35.9697C43.7046 36.0542 43.8594 36.0542 43.9735 35.9697C46.0796 34.4074 47.5175 31.2713 47.5175 27.657C47.5175 24.0426 46.0796 20.9065 43.9735 19.3442Z",
    fill: "#02905D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8385 21.4084C45.3114 20.571 44.6803 19.8687 43.9735 19.3442C43.8595 19.2597 43.7046 19.2597 43.5906 19.3442C41.4846 20.9066 40.0466 24.0426 40.0466 27.6571C40.0466 31.2713 41.4846 34.4074 43.5906 35.9697C43.7046 36.0544 43.8595 36.0544 43.9735 35.9697C46.0796 34.4074 47.5175 31.2713 47.5175 27.6571C47.5175 26.833 47.442 26.0341 47.3015 25.2728",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5577 35.3112C59.6423 35.1972 59.6423 35.0424 59.5577 34.9283C57.9953 32.8224 54.8593 31.3843 51.2449 31.3843C47.6307 31.3843 44.4945 32.8224 42.9322 34.9283C42.8476 35.0424 42.8476 35.1972 42.9322 35.3112C44.4945 37.4172 47.6307 38.8552 51.2449 38.8552C54.8593 38.8552 57.9953 37.4172 59.5577 35.3112Z",
    fill: "#09A76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5577 35.3112C59.6423 35.1972 59.6423 35.0424 59.5577 34.9283C57.9953 32.8224 54.8593 31.3843 51.2449 31.3843C47.6307 31.3843 44.4945 32.8224 42.9322 34.9283C42.8476 35.0424 42.8476 35.1972 42.9322 35.3112C44.4945 37.4172 47.6307 38.8552 51.2449 38.8552C54.8593 38.8552 57.9953 37.4172 59.5577 35.3112Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6177 35.5051C47.5965 35.3619 47.6739 35.2225 47.8066 35.1648C49.5436 34.4086 52.0168 34.6119 54.2912 35.8743C56.5656 37.1368 58.0464 39.1283 58.3233 41.0022C58.3445 41.1454 58.2671 41.2848 58.1344 41.3425C56.3976 42.0988 53.9243 41.8953 51.6499 40.6329C49.3755 39.3704 47.8946 37.379 47.6177 35.5051Z",
    fill: "#02905D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6177 35.5051C47.5965 35.3619 47.6739 35.2225 47.8066 35.1648C49.5436 34.4086 52.0168 34.6119 54.2912 35.8743C56.5656 37.1368 58.0464 39.1283 58.3233 41.0022C58.3445 41.1454 58.2671 41.2848 58.1344 41.3425C56.3976 42.0988 53.9243 41.8953 51.6499 40.6329C49.3755 39.3704 47.8946 37.379 47.6177 35.5051Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3969 31.2841C43.5401 31.3053 43.6793 31.228 43.7371 31.0952C44.4933 29.3584 44.29 26.8851 43.0275 24.6108C41.7651 22.3364 39.7737 20.8555 37.8998 20.5786C37.7565 20.5574 37.6172 20.6347 37.5595 20.7675C36.8031 22.5043 37.0067 24.9776 38.269 27.2519C39.5315 29.5263 41.523 31.0072 43.3969 31.2841Z",
    fill: "#09A76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3969 31.2841C43.5401 31.3053 43.6793 31.228 43.7371 31.0952C44.4933 29.3584 44.29 26.8851 43.0275 24.6108C41.7651 22.3364 39.7737 20.8555 37.8998 20.5786C37.7565 20.5574 37.6172 20.6347 37.5595 20.7675C36.8031 22.5043 37.0067 24.9776 38.269 27.2519C39.5315 29.5263 41.523 31.0072 43.3969 31.2841Z",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6486 56.0591L48.1939 50.5034C53.9862 48.857 55.8743 41.5908 51.6163 37.3328L41.5691 27.2856C37.3111 23.0276 30.0449 24.9157 28.3984 30.708L22.8428 50.2533C21.8361 53.7945 25.1073 57.0657 28.6486 56.0591Z",
    fill: "#FB2B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.755 54.5093L33.3108 34.9639C34.6944 30.0962 40.0468 27.9864 44.2474 29.964L41.5691 27.2855C37.3111 23.0275 30.0449 24.9157 28.3984 30.708L22.8428 50.2534C21.9375 53.438 24.4924 56.4024 27.5917 56.2352C27.5409 55.6795 27.5876 55.0984 27.755 54.5093Z",
    fill: "#E41F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8708 52.0165L48.194 50.5034C53.9863 48.857 55.8743 41.5908 51.6163 37.3328L41.5691 27.2856C37.3111 23.0276 30.0449 24.9157 28.3984 30.708L22.8428 50.2533C21.8361 53.7945 25.1073 57.0657 28.6486 56.0591L38.9229 53.1387",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5731 32.2478L32.67 33.1509",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9334 36.6082L37.0303 37.5112",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2937 40.9685L41.3908 41.8716",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6541 45.3288L45.7511 46.2318",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1073 31.0739L38.2043 31.9769",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4676 35.4342L42.5646 36.3373",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.828 39.7946L46.925 40.6976",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9798 38.2013L31.0769 39.1044",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3403 42.5617L35.4372 43.4647",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7006 46.922L39.7975 47.8251",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.535 43.8388L29.632 44.7418",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8953 48.1991L33.9923 49.1022",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8773 49.8568L27.9743 50.7599",
    stroke: "black",
    strokeWidth: 1.81641,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrawberry);
export default __webpack_public_path__ + "static/media/icon-Strawberry.94da00868b9aa2f19f7c4318cd27319c.svg";
export { ForwardRef as ReactComponent };